import BaseModel from './base';
import Event from './event';

export default class UserResult extends BaseModel {
  constructor(result, url) {
    super(result, url);
    const { scores, places, ...event } = result;
    this.scores = {
      total_journals_score: 0,
      avg_expertises_score: 0,
      sum: 0,
      ...(scores || {}),
    };
    this.places = {
      events: Array.isArray(places?.events) ? places.events : [],
      stages: Array.isArray(places?.stages) ? places.stages : [],
    }; // {id, place, nomination_id}[], (events: id === event_id), (stages: id === stage_id)
    this.event = new Event({ ...event }, '');

    this.certificates = [];
  }

  setCertificates(val = []) {
    this.certificates = Array.isArray(val) ? val : [];
  }
}
